import produce from 'immer';
import { create } from 'zustand';

const useEditNpoProfileStore = create((set) => ({
  open: false,
  nonProfit: null,
  //   header: 'Profile Information',
  //   setExternalOpen: (open, header) =>
  //     set((state) => ({ open: open, header: header, userProfile: state.userProfile })),
  setOpen: (isOpen, nonProfit) =>
    set((state) => ({ open: isOpen, nonProfit: nonProfit })),
  setClose: (isClose) => {
    set((state) => ({ ...state, open: isClose }));
  },
  setEditNonProfit: (nonProfit) => {
    set(
      produce((draft) => {
        draft.nonProfit = nonProfit;
      }),
    );
  },
  join: () => {},
}));

export default useEditNpoProfileStore;
